import React from "react";
import { Wrench, IndianRupeeIcon, Smile } from "lucide-react";
import BestServiceImg from '../../img/bestService-img.png'

const BestServices = () => {
    return (
        <section className="best-services-section">
            <div className="best-services-container">
                <div className="best-services-content">
                    <h2 className="best-services-title">Why We Are The Best</h2>
                    <p className="best-services-description">
                        With years of experience, we ensure you get the highest quality service and customer satisfaction. Here’s why we stand out:
                    </p>
                    <div className="best-services-benefits">
                        <div className="benefit">
                            <div className="benefits-icon-title">
                                <Wrench size={24} color="#f39c12" />
                                <h3>Expert Technicians</h3>
                            </div>
                            <p>Our experienced team ensures the highest quality service for your kitchen appliances.</p>
                        </div>
                        <div className="benefit">
                            <div className="benefits-icon-title">
                                <IndianRupeeIcon size={24} color="#f39c12" />
                                <h3>Affordable Prices</h3>
                            </div>
                            <p>We offer competitive prices without compromising on quality.</p>
                        </div>
                        <div className="benefit">
                            <div className="benefits-icon-title">
                                <Smile size={24} color="#f39c12" />
                                <h3>Customer Satisfaction</h3>
                            </div>
                            <p>We are committed to making sure you are happy with every service we provide.</p>
                        </div>
                    </div>
                </div>
                <div className="best-services-image">
                    <img
                        src={BestServiceImg} 
                        alt="Premium Service"
                        className="best-services-image-img"
                    />
                </div>
            </div>
        </section>
    );
};

export default BestServices;
